export default "__VITE_ASSET__DcjrqNpa__"